import ElementInlineEditing from './ElementInlineEditing.vue';

export { ElementInlineEditing };
